var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-page',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h3',[_vm._v(_vm._s(_vm.$t('pages.applicant.index.heading')))])]},proxy:true}])},[_vm._v(" "),_c('t-grid',[_c('t-grid-cell',[_c('index-table',{attrs:{"query":_vm.query,"fields":_vm.fields,"filters":_vm.filters}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }